<template>
  <div>
    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
        <v-card-title 
          class="d-flex align-center pa-4 text-right popup-header">
          Hapus Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-text 
          class="body-1 font-weight-light text-first line-text-second mt-4">
          Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
        </v-card-text>

        <div v-if="message.error.length > 0"
          class="text-center mx-6 my-4">
          <div
            class="error--text d-flex align-start">
            <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>

        <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-actions
          class="pa-4">
          <v-spacer/>

          <v-btn
            rounded
            width="120"
            @click="deletes()"
            :loading="process.delete"
            :disabled="process.delete"
            color="green"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text">
            Ya, Hapus
          </v-btn>

          <v-btn
            rounded
            width="120"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            :disabled="process.delete"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      v-if="dialog.form"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
        <div 
          class="d-flex align-start pa-4 popup-header">
          <div
            class="fs-17 font-weight-bold" style="width: 450px;">
            {{ form.id === '' ? 'Tambah' : 'Ubah' }} Data Detail RAB Internal
          </div>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </div>
        
        <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-text 
          class="py-0 my-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <table class="mb-3">
                <tr>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px 2px 4px; text-align: left; width: 100px; min-width: 100px; max-width: 100px; font-weight: 600;">
                    Sub Total
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px; text-align: center; width: 1px; white-space: nowrap;">
                    :
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 6px 2px; text-align: left; width: 100%; min-width: 100%; max-width: 100%; font-weight: 600;">
                    {{ form.total_price*1 | price }}
                  </td>
                </tr>
              </table>

              <v-divider 
                class="mb-3"
                style="border-top: 1px solid #e0e0e0;"/>

              <table class="mb-3">
                <tr>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px 2px 4px; text-align: left; width: 100px; min-width: 100px; max-width: 100px;">
                    Nama
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px; text-align: center; width: 1px; white-space: nowrap;">
                    :
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 6px 2px; text-align: left; width: 100%; min-width: 100%; max-width: 100%;">
                    <ValidationProvider
                      name="Nama" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <!-- <div class="mb-2 font_weight_600 fs-13 black_one">
                        <span class="red--text">*</span>
                        Nama
                      </div> -->
      
                      <v-autocomplete
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
      
                        :color="set_color"
                        placeholder="Nama"
                        :items="satuan.filter(item => form.category === item.category)"
                        item-text="name"
                        item-value="name"
                        v-on:change="form.unit = satuan.find(item => item.name === form.name).unit; form.price =((satuan.find(item => item.name === form.name).price)*1).toString().split('.').join(','); getMasterAhsp(satuan.find(item => item.name === form.name).id)"
      
                        hide-details
      
                        v-model="form.name"
                        :success="form.name !== '' && valid"
                        :error-messages="errors"
                        required
                        class="mb-0"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>
      
                          <div v-if="form.name !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>
                  </td>
                </tr>
                <tr>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px 2px 4px; text-align: left; width: 100px; min-width: 100px; max-width: 100px;">
                    AHSP
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px; text-align: center; width: 1px; white-space: nowrap;">
                    :
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 6px 2px; text-align: left; width: 100%; min-width: 100%; max-width: 100%;">
                    <ValidationProvider
                      name="AHSP" 
                      rules="" 
                      v-slot="{ errors, valid }">
                      <!-- <div class="mb-2 font_weight_600 fs-13 black_one">
                        <span class="red--text">*</span>
                        AHSP
                      </div> -->
      
                      <v-autocomplete
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
      
                        :color="set_color"
                        placeholder="AHSP"
                        :items="master_ahsp"
                        item-text="name"
                        item-value="name"
                        v-on:change="form.koefisien = master_ahsp.find(item => item.name === form.ahsp_name).koefisien;"
      
                        hide-details
      
                        v-model="form.ahsp_name"
                        :success="form.ahsp_name !== '' && valid"
                        :error-messages="errors"
                        required
                        class="mb-0"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>
      
                          <div v-if="form.name !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-autocomplete>
                    </ValidationProvider>
                  </td>
                </tr>
                <tr>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px 2px 4px; text-align: left; width: 100px; min-width: 100px; max-width: 100px;">
                    Satuan
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px; text-align: center; width: 1px; white-space: nowrap;">
                    :
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 6px 2px; text-align: left; width: 100%; min-width: 100%; max-width: 100%;">
                    <ValidationProvider 
                      name="Satuan" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <!-- <div class="mb-2 font_weight_600 fs-13 black_one">
                        <span class="red--text">*</span>
      
                        Satuan
                      </div> -->
      
                      <v-text-field
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
      
                        :color="set_color"
                        placeholder="Satuan"
      
                        hide-details
      
                        v-model="form.unit"
                        :success="form.unit !== '' && valid"
                        :error-messages="errors"
                        required
                        class="mb-0"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>
      
                          <div v-if="form.unit !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </td>
                </tr>
                <tr>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px 2px 4px; text-align: left; width: 100px; min-width: 100px; max-width: 100px;">
                    Harga
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px; text-align: center; width: 1px; white-space: nowrap;">
                    :
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 6px 2px; text-align: left; width: 100%; min-width: 100%; max-width: 100%;">
                    <ValidationProvider 
                      name="Harga" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <!-- <div class="mb-2 font_weight_600 fs-13 black_one">
                        <span class="red--text">*</span>
      
                        Harga
                      </div> -->
      
                      <v-currency-field
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
      
                        :color="set_color"
                        placeholder="Harga"
      
                        v-on:change="form.total_price = form.price * form.volume;"
      
                        hide-details
                        :auto-decimal-mode="false"
                        :decimal-length="2"
      
                        v-model="form.price"
                        :success="form.price !== '' && valid"
                        :error-messages="errors"
                        required
                        class="mb-0"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>
      
                          <div v-if="form.price !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-currency-field>
                    </ValidationProvider>
                  </td> 
                </tr>
                <tr>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px 2px 4px; text-align: left; width: 100px; min-width: 100px; max-width: 100px;">
                    Volume
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px; text-align: center; width: 1px; white-space: nowrap;">
                    :
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 6px 2px; text-align: left; width: 100%; min-width: 100%; max-width: 100%;">
                    <ValidationProvider 
                      name="Volume" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <!-- <div class="mb-2 font_weight_600 fs-13 black_one">
                        <span class="red--text">*</span>
      
                        Volume
                      </div> -->
      
                      <v-currency-field
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
      
                        :color="set_color"
                        placeholder="Volume"
                        v-on:change="form.total_price = form.price * form.volume;"
      
                        hide-details
                        :auto-decimal-mode="false"
                        :decimal-length="2"
      
                        v-model="form.volume"
                        :success="form.volume !== '' && valid"
                        :error-messages="errors"
                        required
                        class="mb-0"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>
      
                          <div v-if="form.volume !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-currency-field>
                    </ValidationProvider>
                  </td>
                </tr>
                <tr>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px 2px 4px; text-align: left; width: 100px; min-width: 100px; max-width: 100px;">
                    Koefisien
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 2px 12px; text-align: center; width: 1px; white-space: nowrap;">
                    :
                  </td>
                  <td style="font-size: 15px; border: 1px solid #fff; color: black; border-left: none; padding: 6px 2px; text-align: left; width: 100%; min-width: 100%; max-width: 100%;">
                    <ValidationProvider 
                      name="Koefisien" 
                      rules="" 
                      v-slot="{ errors, valid }">
                      <!-- <div class="mb-2 font_weight_600 fs-13 black_one">
                        <span class="red--text">*</span>
      
                        Koefisien
                      </div> -->
      
                      <v-currency-field
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
                        :auto-decimal-mode="false"
                        :decimal-length="2"
      
                        :color="set_color"
                        placeholder="Koefisien"
      
                        hide-details
      
                        v-model="form.koefisien"
                        :success="form.koefisien !== '' && valid"
                        :error-messages="errors"
                        required
                        class="mb-0"
                        style="border-radius: 10px;">
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              {{ errors[0] }}
                            </v-tooltip>
                          </div>
      
                          <div v-if="form.koefisien !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-currency-field>
                    </ValidationProvider>
                  </td>
                </tr>
              </table>

              <!-- <v-row>
                <v-col cols="6" class="py-0">
                </v-col>
                <v-col cols="6" class="py-0">
                </v-col>
                <v-col cols="4" class="py-0">
                </v-col>
                <v-col cols="4" class="py-0">
                </v-col>
                <v-col cols="4" class="py-0">
                  <ValidationProvider 
                    name="Sub Total" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="mb-2 font_weight_600 fs-13 black_one">
                      <span class="red--text">*</span>

                      Sub Total
                    </div>

                    <v-currency-field
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Sub Total"

                      hide-details
                      readonly

                      v-model="form.total_price"
                      :success="form.total_price !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-0"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.total_price !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-currency-field>
                  </ValidationProvider>
                </v-col>
              </v-row> -->
            </v-form>
          </ValidationObserver>

        </v-card-text>
        
        <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/>
        
        <v-card-actions
          class="pa-4">
          <div v-if="message.error.length > 0"
            class="text-left">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
          <v-spacer/>

          <v-btn
            @click="save()"
            :loading="process.form"
            :disabled="process.form"
            width="120"
            elevation="0"
            color="green"
            rounded
            class="body-2 font-weight-bold text-capitalize white--text">
            Simpan
          </v-btn>

          <v-btn
            @click="dialog.form = false; reset();"
            :disabled="process.form"
            width="120"
            outlined
            elevation="0"
            color="red"
            rounded
            class="body-2 font-weight-bold text-capitalize white--text">
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="view" v-if="!process.load">
      <div :class="list.length < 1 ? '' : 'wrapper_internal_detail'">
        <table style="border: 1px solid #ededed; width: 100%;" class="table">
          <tr>
            <!-- <th style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: center;">No Rekening</th> -->
            <!-- <th class="sticky-col one-detail-col" style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">No</th> -->
            <th class="sticky-col second-detail-col-detail-rab-internal" style="font-size: 12px; z-index: 1; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 320px; min-width: 320px; max-width: 320px;" :style="`background-color: ${set_color};`">Jenis Pekerjaan</th>
            <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">Volume</th>
            <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">Satuan</th>
            <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">Koefisien</th>
            <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 180px; min-width: 180px; max-width: 180px;" :style="`background-color: ${set_color};`">Harga Satuan</th>
            <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 180px; min-width: 180px; max-width: 180px;" :style="`background-color: ${set_color};`">Sub Total</th>
            <!-- <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">Pajak</th>
            <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">Markup</th>
            <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 80px; min-width: 80px; max-width: 80px;" :style="`background-color: ${set_color};`">Diskon</th>
            <th style="font-size: 12px; border: 1px solid #fff; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 180px; min-width: 180px; max-width: 100%;" :style="`background-color: ${set_color};`">Net Harga</th> -->
          </tr>
          <tr v-for="(item, index) in list" :key="index" @click="selected.row = (((`100${index}`) + index) * (i+1))" :class="selected.row === (((`100${index}`) + index) * (i+1)) ? 'selected' : ''">
            <!-- <td class="sticky-col one-detail-col" style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 2px; text-align: center;" :style="item.num_children === 1 ? 'font-weight: 600;' : item.num_children === 0 ? 'font-weight: 700;' : ''">
              <span v-if="item.num_children === 2">{{ item.no_par_par }}.</span><span v-if="item.num_children !== 0">{{ item.no_par }}.</span>{{ item.no }}
            </td> -->
            <td class="sticky-col second-detail-col-detail-rab-internal" :class="item.num_children === 4  ? 'pl-11 d-flex' : item.num_children === 3 ? 'd-flex' : ''" style="font-size: 12px; background-color: #fff; padding: 8px 12px; text-align: left;" :style="item.num_children === 4 ? 'border: 0.5px solid #ededed; min-width: 100%;' : item.num_children === 3 ? 'padding-left: 34px; border: 0.5px solid #ededed; min-width: 100%;' : item.num_children === 1 ? 'padding-left: 18px; font-weight: 600; border: 1px solid #ededed;' : item.num_children === 0 ? 'font-weight: 700; border: 1px solid #ededed;' : 'padding-left: 24px; border: 1px solid #ededed;'">
              <span v-if="item.code !== undefined">{{ item.code }}. </span>{{ item.name }}
              <div v-if="detail_project.status === 'Persiapan'" class="d-flex">
                <v-tooltip 
                  top v-if="item.num_children === 3">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="fs-12 green--text ml-3" v-bind="attrs" v-on="on" @click="reset(item); dialog.form = true;" style="cursor: pointer">
                      Tambah
                    </div>
                  </template>
  
                  <span>Tambah</span>
                </v-tooltip>
  
                <v-tooltip 
                  top v-if="item.num_children === 4">
                  <template v-slot:activator="{ on, attrs }">
                    <!-- <v-btn
                      @click="selected.rencana = [items]; toDetail(item.id, items.title); selected.list = [item];"
                      
                      v-bind="attrs"
                      v-on="on"
  
                      min-width="20"
                      x-small
                      rounded
                      color="green"
                      elevation="0"
                      class="white--text text-capitalize mr-1 px-0"
                      style="font-weight: 600; border-radius: 5px;">
                      <v-icon x-small>mdi-plus-circle</v-icon>
                    </v-btn>
                  </template> -->
                    <div class="fs-12 primary--text ml-3" v-bind="attrs" v-on="on" @click="resetChild(item); dialog.form = true;" style="cursor: pointer">
                      Ubah
                    </div>
                  </template>
  
                  <span>Ubah</span>
                </v-tooltip>
                <v-tooltip 
                  top v-if="item.num_children === 4">
                  <template v-slot:activator="{ on, attrs }">
                    <!-- <v-btn
                      @click="selected.rencana = [items]; toDetail(item.id, items.title); selected.list = [item];"
                      
                      v-bind="attrs"
                      v-on="on"
  
                      min-width="20"
                      x-small
                      rounded
                      color="green"
                      elevation="0"
                      class="white--text text-capitalize mr-1 px-0"
                      style="font-weight: 600; border-radius: 5px;">
                      <v-icon x-small>mdi-plus-circle</v-icon>
                    </v-btn>
                  </template> -->
                    <div class="fs-12 red--text ml-3" v-bind="attrs" v-on="on" @click="toDelete(item.id, item.rab_id)" style="cursor: pointer">
                      Hapus
                    </div>
                  </template>
  
                  <span>Hapus</span>
                </v-tooltip>
              </div>


            </td>
            <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left;">
              <span v-if="item.num_children === 4">
                {{ item.volume*1 }}
              </span>
            </td>
            <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left;">
              <span v-if="item.num_children === 4">
                {{ item.unit }}
              </span>
            </td>
            <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left;">
              <span v-if="item.num_children === 4">
                {{ (item.koefisien*1) | number_dec }}
              </span>
            </td>
            <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left;">
              <span v-if="item.num_children === 4">
                {{ item.price*1 | price }}
              </span>
            </td>
            <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left;">
              <span v-if="item.num_children === 4">
                {{ item.total_price*1 | price }}
              </span>
            </td>
            <!-- <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left;">
              <span v-if="item.num_children === 4">
                {{ item.tax_percent*1 }}%
              </span>
            </td>
            <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left;">
              <span v-if="item.num_children === 4">
                {{ item.markup_percent*1 }}%
              </span>
            </td>
            <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left;">
              <span v-if="item.num_children === 4">
                {{ item.discount_percent*1 }}%
              </span>
            </td>
            <td style="font-size: 12px; border: 1px solid #ededed; background-color: #fff; padding: 8px 12px; text-align: left;">
              <span v-if="item.num_children === 4">
                {{ item.nett_price*1 | price }}
              </span>
            </td> -->
          </tr>
          <!-- <tr>
            <th colspan="4" style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Total</th>
            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Rp. 510.000.000</th>
            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Rp. 85.000.000</th>
            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;"></th>
            <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;"></th>
          </tr> -->
        </table>
      </div>
      <v-card-text
        v-if="list.length === 0"
        class="pb-0 my-4" style="height: calc( 100vh - 295px ); display: flex; align-items: center; justify-content: center;">
        <div class="text-center">
          <v-img 
            class="mx-auto"
            contain
            alt="vuetify"
            :width="90"
            :height="90"
            :src="require('@/assets/image/empty.png')">
            <!-- <template v-slot:placeholder>
              <v-row
                class=" "
                align="center"
                justify="center">
                <v-progress-circular 
                  indeterminate 
                  :color="set_color">
                </v-progress-circular>
              </v-row>
            </template> -->
          </v-img>
          <div class="mt-3 fs-16">
            Belum ada data Data RAB Internal
          </div>
        </div>
      </v-card-text>
    </div>
  </div>
</template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      props: {
        detail_project: {
          type: Object,
          default: () => {}
        }
      },
      data () {
        return {
          dialog: {
            form: false,
            delete: false,
            reset: false,
            export: false,
            image: false,
            document: false
          },
          list: [],
          satuan: [],
          selected: {
            row: 0,
            delete: [],
            rab_id: []
          },
          master_ahsp: [],
          form: {
            id: '',
            project_id: '',
            rab_id:'',
            name:'',
            category:'',
            unit:'',
            price:'',
            volume:'',
            total_price:'',
            tax_percent:'',
            markup_percent:'',
            discount_percent:'',
            nett_price:'',
            grand_total:'',
            tax_service_percent: ''
          },
          process: {
            load: false,
            delete: false,
            reset: false,
            form: false,
            export: false,
            image: false,
            document: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      // props: {
      //   list: {
      //     type: Array,
      //     default: []
      //   },
      // },
      watch: {
      },
      computed: {
        rps() {
          return this.$vuetify.breakpoint.name
        },
        set_color () {
          return this.$store.state.color
        }
      },
      mounted () {
        this.fetchSatuan()
        // this.fetchMasterAhsp()
        this.fetch()
      },
      methods: {
        async fetchSatuan () {
          let params = {
            pagination_bool: false,
          }

          await get(`ahsp/data`, { params })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              this.satuan = res.results.data
            }
          })
        },
        // async fetchMasterAhsp () {
        //   let params = {
        //     pagination_bool: false,
        //   }

        //   await get(`ahsp/uraian/data`, { params })
        //   .then(response => {
        //     let res = response.data

        //     if (res.status === 200) {
        //       this.master_ahsp = res.results.data
        //     }
        //   })
        // },
        async getMasterAhsp (id, toEdit) {
          if(toEdit === undefined){
            this.form.ahsp_name = ''
            this.form.koefisien = ''
          }
          let params = {
            ahsp_id: id
          }

          await get(`ahsp/uraian/options`, { params })
          .then(response => {
            let res = response.data

            if (res.status === 200) {
              this.master_ahsp = res.results.data
            }
          })
        },
        async fetch (pagination = { row: 20, page: 1 }) {
        
        this.paginationList = pagination
        
        this.process.load = true

        this.limit = pagination.row
        let params = {
          search: this.search,
          pagination_bool: false,
          project_id: this.$route.params.id,
          sort: '-id',
        }
        let url = 'project/rab/detail/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.list = []
            res.results.data.map((item, index_par) => {
              this.list.push({
                ...item,
                num_children: 0,
                no_par: '',
                detail: [],
                no: index_par === 0 ? 'I' : index_par === 1 ? 'II' : index_par === 2 ? 'III' : index_par === 3 ? 'IV' : index_par === 4 ? 'V' : index_par === 5 ? 'VI' : index_par === 6 ? 'VII' : index_par === 7 ? 'VIII' : index_par === 8 ? 'IX' : index_par === 9 ? 'X' : index_par === 10 ? 'XI' : index_par === 11 ? 'XII' : index_par === 12 ? 'XIII' : index_par === 13 ? 'XIV' : index_par === 14 ? 'XV' : index_par === 15 ? 'XVI' : index_par === 16 ? 'XVII' : index_par === 17 ? 'XVIII' : index_par === 18 ? 'XIX' : index_par === 19 ? 'XX' : index_par === 20 ? 'XXI' : index_par === 21 ? 'XXII' : index_par === 22 ? 'XXIII' : index_par === 23 ? 'XXIV' : index_par === 24 ? 'XXV' : index_par === 25 ? 'XXVI' : index_par === 26 ? 'XXVII' : index_par === 27 ? 'XXVIII' : index_par === 28 ? 'XXIX' : index_par === 29 ? 'XXX' : index_par === 30 ? 'XXXI' : index_par === 31 ? 'XXXII' : index_par === 32 ? 'XXXIII' : index_par === 33 ? 'XXXIV' : index_par === 34 ? 'XXXV' : index_par === 35 ? 'XXXVI' : index_par === 36 ? 'XXXVII' : index_par === 37 ? 'XXXVIII' : index_par === 38 ? 'XXXIX' : index_par === 39 ? 'XL' : index_par === 40 ? 'XLI' : index_par === 41 ? 'XLII' : index_par === 42 ? 'XLIII' : index_par === 43 ? 'XLIV' : index_par === 44 ? 'XLV' : index_par === 45 ? 'XLVI' : '',
                is_child: item.child.length > 0 ? true : false
              })
              if(item.child.length > 0){
                item.child.map((child, index) => {
                  if(child.child.length > 0){
                    this.list.push(
                      {
                        ...child,
                        num_children: 1,
                        no_par: index_par === 0 ? 'I' : index_par === 1 ? 'II' : index_par === 2 ? 'III' : index_par === 3 ? 'IV' : index_par === 4 ? 'V' : index_par === 5 ? 'VI' : index_par === 6 ? 'VII' : index_par === 7 ? 'VIII' : index_par === 8 ? 'IX' : index_par === 9 ? 'X' : index_par === 10 ? 'XI' : index_par === 11 ? 'XII' : index_par === 12 ? 'XIII' : index_par === 13 ? 'XIV' : index_par === 14 ? 'XV' : index_par === 15 ? 'XVI' : index_par === 16 ? 'XVII' : index_par === 17 ? 'XVIII' : index_par === 18 ? 'XIX' : index_par === 19 ? 'XX' : index_par === 20 ? 'XXI' : index_par === 21 ? 'XXII' : index_par === 22 ? 'XXIII' : index_par === 23 ? 'XXIV' : index_par === 24 ? 'XXV' : index_par === 25 ? 'XXVI' : index_par === 26 ? 'XXVII' : index_par === 27 ? 'XXVIII' : index_par === 28 ? 'XXIX' : index_par === 29 ? 'XXX' : index_par === 30 ? 'XXXI' : index_par === 31 ? 'XXXII' : index_par === 32 ? 'XXXIII' : index_par === 33 ? 'XXXIV' : index_par === 34 ? 'XXXV' : index_par === 35 ? 'XXXVI' : index_par === 36 ? 'XXXVII' : index_par === 37 ? 'XXXVIII' : index_par === 38 ? 'XXXIX' : index_par === 39 ? 'XL' : index_par === 40 ? 'XLI' : index_par === 41 ? 'XLII' : index_par === 42 ? 'XLIII' : index_par === 43 ? 'XLIV' : index_par === 44 ? 'XLV' : index_par === 45 ? 'XLVI' : '',
                        no: index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : '',
                        is_child: true,
                        detail: [],
                      }
                    )
                    child.child.map((child2, index2) => {
                      this.list.push(
                        {
                          ...child2,
                          num_children: 2,
                          no_par_par: index_par === 0 ? 'I' : index_par === 1 ? 'II' : index_par === 2 ? 'III' : index_par === 3 ? 'IV' : index_par === 4 ? 'V' : index_par === 5 ? 'VI' : index_par === 6 ? 'VII' : index_par === 7 ? 'VIII' : index_par === 8 ? 'IX' : index_par === 9 ? 'X' : index_par === 10 ? 'XI' : index_par === 11 ? 'XII' : index_par === 12 ? 'XIII' : index_par === 13 ? 'XIV' : index_par === 14 ? 'XV' : index_par === 15 ? 'XVI' : index_par === 16 ? 'XVII' : index_par === 17 ? 'XVIII' : index_par === 18 ? 'XIX' : index_par === 19 ? 'XX' : index_par === 20 ? 'XXI' : index_par === 21 ? 'XXII' : index_par === 22 ? 'XXIII' : index_par === 23 ? 'XXIV' : index_par === 24 ? 'XXV' : index_par === 25 ? 'XXVI' : index_par === 26 ? 'XXVII' : index_par === 27 ? 'XXVIII' : index_par === 28 ? 'XXIX' : index_par === 29 ? 'XXX' : index_par === 30 ? 'XXXI' : index_par === 31 ? 'XXXII' : index_par === 32 ? 'XXXIII' : index_par === 33 ? 'XXXIV' : index_par === 34 ? 'XXXV' : index_par === 35 ? 'XXXVI' : index_par === 36 ? 'XXXVII' : index_par === 37 ? 'XXXVIII' : index_par === 38 ? 'XXXIX' : index_par === 39 ? 'XL' : index_par === 40 ? 'XLI' : index_par === 41 ? 'XLII' : index_par === 42 ? 'XLIII' : index_par === 43 ? 'XLIV' : index_par === 44 ? 'XLV' : index_par === 45 ? 'XLVI' : '',
                          no_par:index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : '',
                          no: index2 + 1,
                          is_child: false
                        }
                      )
                      this.list.push({
                        name: 'Material',
                        id: child2.id,
                        num_children: 3,
                        no: ''
                      })
                      if(child2.detail.material.length > 0) {
                        child2.detail.material.map((child3, index3) => {
                          this.list.push({
                            ...child3,
                            num_children: 4
                          })
                        })
                      }
                      this.list.push({
                        name: 'Upah',
                        id: child2.id,
                        num_children: 3,
                        no: ''
                      })
                      if(child2.detail.upah.length > 0) {
                        child2.detail.upah.map((child3, index3) => {
                          this.list.push({
                            ...child3,
                            num_children: 4
                          })
                        })
                      }
                      this.list.push({
                        name: 'Alat',
                        id: child2.id,
                        num_children: 3,
                        no: ''
                      })
                      if(child2.detail.alat.length > 0) {
                        child2.detail.alat.map((child3, index3) => {
                          this.list.push({
                            ...child3,
                            num_children: 4
                          })
                        })
                      }
                    })
                  } else {
                    this.list.push(
                      {
                        ...child,
                        num_children: 1,
                        no_par: index_par === 0 ? 'I' : index_par === 1 ? 'II' : index_par === 2 ? 'III' : index_par === 3 ? 'IV' : index_par === 4 ? 'V' : index_par === 5 ? 'VI' : index_par === 6 ? 'VII' : index_par === 7 ? 'VIII' : index_par === 8 ? 'IX' : index_par === 9 ? 'X' : index_par === 10 ? 'XI' : index_par === 11 ? 'XII' : index_par === 12 ? 'XIII' : index_par === 13 ? 'XIV' : index_par === 14 ? 'XV' : index_par === 15 ? 'XVI' : index_par === 16 ? 'XVII' : index_par === 17 ? 'XVIII' : index_par === 18 ? 'XIX' : index_par === 19 ? 'XX' : index_par === 20 ? 'XXI' : index_par === 21 ? 'XXII' : index_par === 22 ? 'XXIII' : index_par === 23 ? 'XXIV' : index_par === 24 ? 'XXV' : index_par === 25 ? 'XXVI' : index_par === 26 ? 'XXVII' : index_par === 27 ? 'XXVIII' : index_par === 28 ? 'XXIX' : index_par === 29 ? 'XXX' : index_par === 30 ? 'XXXI' : index_par === 31 ? 'XXXII' : index_par === 32 ? 'XXXIII' : index_par === 33 ? 'XXXIV' : index_par === 34 ? 'XXXV' : index_par === 35 ? 'XXXVI' : index_par === 36 ? 'XXXVII' : index_par === 37 ? 'XXXVIII' : index_par === 38 ? 'XXXIX' : index_par === 39 ? 'XL' : index_par === 40 ? 'XLI' : index_par === 41 ? 'XLII' : index_par === 42 ? 'XLIII' : index_par === 43 ? 'XLIV' : index_par === 44 ? 'XLV' : index_par === 45 ? 'XLVI' : '',
                        no: index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : '',
                        is_child: false,
                        detail: [],
                      }
                    )
                  }
                }
                )
                // item.child.map((child, index) => {
                //   this.list.push(
                //     {
                //       ...child,
                //       num_children: 1,
                //       no: index === 0 ? 'a' : index === 1 ? 'b' : index === 2 ? 'c' : index === 3 ? 'd' : index === 4 ? 'e' : index === 5 ? 'f' : index === 6 ? 'g' : index === 7 ? 'h' : index === 8 ? 'i' : index === 9 ? 'j' : index === 10 ? 'k' : index === 11 ? 'l' : index === 12 ? 'm' : index === 13 ? 'n' : index === 14 ? 'o' : index === 15 ? 'p' : index === 16 ? 'q' : index === 17 ? 'r' : index === 18 ? 's' : index === 19 ? 't' : index === 20 ? 'u' : index === 21 ? 'v' : index === 22 ? 'w' : index === 23 ? 'x' : index === 24 ? 'y' : index === 25 ? 'z' : index === 26 ? 'aa' : index === 27 ? 'ab' : index === 28 ? 'ac' : index === 29 ? 'ad' : index === 30 ? 'ae' : index === 31 ? 'af' : index === 32 ? 'ag' : index === 33 ? 'ah' : index === 34 ? 'ai' : index === 35 ? 'aj' : index === 36 ? 'ak' : index === 37 ? 'al' : index === 38 ? 'am' : index === 39 ? 'an' : index === 40 ? 'ao' : index === 41 ? 'ap' : index === 42 ? 'aq' : index === 43 ? 'ar' : index === 44 ? 'as' : index === 45 ? 'at' : index === 46 ? 'au' : index === 47 ? 'av' : index === 48 ? 'aw' : index === 49 ? 'ax' : index === 50 ? 'ay' : index === 51 ? 'az' : index === 52 ? 'ba' : index === 53 ? 'bb' : index === 54 ? 'bc' : index === 55 ? 'bd' : index === 56 ? 'be' : ''
                //     }
                //   )
                // })
                // item.child.map(child => {
                //   if(child.child.length > 0){
                //     child.child.map((child2, index2) => {
                //       this.list.push(
                //         {
                //           ...child2,
                //           num_children: 2,
                //           no: index2 + 1
                //         }
                //       )
                //     })
                //   }
                // })
              }
            })
            this.pagination = res.results.pagination !== undefined ? res.results.pagination : {}
            this.process.load = false
            // this.fetchSummary()
          }
        })
      },
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: '',
          project_id: this.$route.params.id,
          rab_id: item !== undefined ? item.id : '',
          name: item !== undefined ? item.name : '',
          category: item.name,
          unit: '',
          price: '',
          volume: '',
          total_price: '',
          tax_percent: 0,
          markup_percent: 0,
          discount_percent: 0,
          nett_price: 0,
          grand_total: 0,
          tax_service_percent: 0,
          ahsp_name: '',
          koefisien: '',
        }

        this.process.form = false

        this.message.error = ''

        if (this.dialog.form) this.fetchSatuan()
      },
      resetChild (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item.id,
          project_id: this.$route.params.id,
          rab_id: item !== undefined ? item.rab_id : '',
          name: item !== undefined ? item.name : '',
          category: item.category,
          unit: item.unit,
          price: (item.price*1).toString().split('.').join(','),
          volume: (item.volume*1).toString().split('.').join(','),
          total_price: item.total_price*1,
          tax_percent: item.tax_percent*1,
          markup_percent: item.markup_percent*1,
          discount_percent: item.discount_percent*1,
          nett_price: item.nett_price*1,
          grand_total: item.grand_total,
          tax_service_percent: item.tax_service_percent,
          ahsp_name: item.ahsp_name,
          koefisien: (item.koefisien*1).toString().split('.').join(','),
        }
        this.getMasterAhsp(this.satuan.find(item => item.name === this.form.name).id, 'edit')

        this.process.form = false

        this.message.error = ''

        if (this.dialog.form) this.fetchSatuan()
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true
          this.form.grand_total = this.form.nett_price
          this.form.price = (this.form.price).toString().split(',').join('.')
          this.form.volume = (this.form.volume).toString().split(',').join('.')
          this.form.total_price = (this.form.total_price).toString().split(',').join('.')
          this.form.koefisien = (this.form.koefisien).toString().split(',').join('.')

          let url = this.form.id === '' ? 'project/rab/detail/add' : 'project/rab/detail/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetch()
              // if (this.form.id === '') {
              // } else {
              //   this.fetch(this.paginationList)
              // }
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id, rad_id) {
        this.selected.delete = [id]
        this.selected.rab_id = [rad_id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`project/rab/detail/delete`, {
          data: {
            id: this.selected.delete[0],
            rab_id: this.selected.rab_id[0],
            project_id: this.$route.params.id
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      },
      }
    }
  </script>

<style>
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
  color: #000;
}

.view {
  margin: auto;
  width: 100%;
}

.wrapper_internal_detail { 
  overflow-y: auto; 
  height: calc(100vh - 160px); 
} 
.wrapper_internal_detail th { 
  position: sticky; 
  top: 0; 
  /* background-color: #080679 !important; */
} 

.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  /* background-color: #080679 !important; */
}

.one-detail-col {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  left: 0px;
}

.second-detail-col-detail-rab-internal {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 0px;
}
tr:hover {background-color: #fff;}
tr.selected {background-color: #fff;}
</style>